module.exports = __webpack_public_path__ + "2a7b4a6dc1685371ba884ddd10a4782f.pdf";